import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=e97d360c&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=e97d360c&prod&lang=scss&scoped=true"
import style1 from "./Dialog.vue?vue&type=style&index=1&id=e97d360c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97d360c",
  null
  
)

export default component.exports